import CloseOutlined from '@mui/icons-material/CloseOutlined'
import MenuOutlined from '@mui/icons-material/MenuOutlined'
import { ComponentProps, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Typography } from './ui/typography'

type NavMenuProps = ComponentProps<'div'> & {
  links: {
    label: string
    href: string
  }[]
}

export function NavMenu({ links = [], ...props }: NavMenuProps) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div {...props}>
      <button
        onClick={toggleMenu}
        className="relative z-50"
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
      >
        {isOpen ? (
          <CloseOutlined sx={{ fontSize: 24 }} />
        ) : (
          <MenuOutlined sx={{ fontSize: 24 }} />
        )}
      </button>

      <div
        className={`absolute inset-0 z-40 mt-16 h-screen w-full bg-white transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col gap-6 px-3 pt-6">
          {links.map((link) => (
            <Link
              to={link.href}
              key={link.href}
              onClick={() => setIsOpen(false)}
              className="rounded-md p-2 transition-colors hover:bg-gray-50"
            >
              <Typography className="font-semibold sm:text-lg">
                {link.label}
              </Typography>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
